export default __webpack_public_path__ + "static/img-slider-09-d9620f488889997d5410ace87d6a3b7e.png";